import { Avatar, Box, Divider, Grid, IconButton, Stack, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { LanguageContext } from '../../../../../../../libs/Context';
import { MdOutlineModeEdit } from 'react-icons/md';
import { getSpeakersList } from '../../../../../../actions/meeting_actions';
import { capitalizeFirstLetter } from '../../../../../../../libs/HelperContent';

const Speakers = (props) =>
{
	const { meetingId, handleNavi } = props;
	const [ speakerListData, setSpeakerListData ] = useState({
		count        : 0,
		pageSkip     : 0,
		itemsPerPage : 15,
		speakerData  : [],
		loading      : false
	});
	const { pageSkip, itemsPerPage, speakerData } = speakerListData;
	const { language } = useContext(LanguageContext);

	const fetchSpeakerRecords = async () =>
	{
		pageSkip === 0 && setSpeakerListData((prev) => ({
			...prev,
			loading : true
		}));

		const queryParams = {
			sessionId : meetingId, // completed_webinar_id
			limit     : itemsPerPage || 15,
			skip      : pageSkip || 0
		};

		try
		{
			const res = await getSpeakersList(queryParams);

			if (res?.status)
			{
				// update states to render over page...
				setSpeakerListData((prev) => ({
					...prev,
					loading     : false,
					count       : res?.data.length,
					speakerData : res?.data
				}));
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.log('error***', err);
		}
		setSpeakerListData((prev) => ({
			...prev,
			loading : false
		}));
	};

	useEffect(() =>
	{
		fetchSpeakerRecords();
	}, []);

	if (speakerData?.length === 0) return <></>;

	return (
		<>
			<Divider sx={{ border: '1px solid #A3A3A3' }}/>
			<Grid item xs={12}>
				<Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
					<Typography fontWeight='var(--font500)'>{language.speakers}</Typography>
				</Stack>
			</Grid>
			<Grid container spacing={2} mt={1} mb={4}>
				{speakerData.map((speaker:any, index) => (
					<Grid item xs={12} sm={6} md={6} key={`${speaker?.speakerName}-${index}`} position={'relative'} mt={2}>
						<Stack direction={'column'} width={'var(--percent100)'} spacing={1} border={'1px solid rgba(224, 224, 224, 1)'} borderRadius={'var(--pixel8)'} p='var(--pixel8)' height='var(--percent100)'>
							<Grid display={'flex'} justifyContent={'end'} alignItems={'center'}>
								<IconButton>
									<MdOutlineModeEdit color='var(--txtColorBlackL)' cursor={'pointer'} onClick={() => handleNavi(4)}/>
								</IconButton>
							</Grid>
							<Typography variant='body2' fontWeight='var(--font500)' mt='0px !important'>{capitalizeFirstLetter(speaker?.speakerName ?? 'NA')}</Typography>
							<Typography variant='body2' fontWeight='var(--font500)'>{speaker?.designation ?? 'NA'}</Typography>
							<Typography variant='body2' display='flex' style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: 'var(--percent100)' }}>{speaker?.speakerEmail ?? 'NA'}</Typography>
							<Typography variant='body2' color={'rgba(115, 115, 115, 1)'}>{speaker?.description ?? 'NA'}</Typography>
							<Stack py='var(--pixel8)' direction={'row'} spacing={1}>
								{speaker?.facebookUrl && <Box sx={{ width: 'var(--pixel28)', height: 'var(--pixel28)' }}><img src='/images/icons/facebook.svg' alt={speaker?.facebookUrl ?? ''} style={{ width: 'var(--percent100)', height: 'var(--percent100)', objectFit: 'cover' }} /></Box>}
								{speaker?.linkedinUrl && <Box sx={{ width: 'var(--pixel28)', height: 'var(--pixel28)' }}><img src='/images/icons/linkedIn.svg' alt={speaker?.linkedinUrl ?? ''} style={{ width: 'var(--percent100)', height: 'var(--percent100)', objectFit: 'cover' }} /></Box>}
								{speaker?.twitterUrl && <Box sx={{ width: 'var(--pixel28)', height: 'var(--pixel28)' }}><img src='/images/icons/twitter.svg' alt={speaker?.twitterUrl ?? ''} style={{ width: 'var(--percent100)', height: 'var(--percent100)' }} /></Box>}
							</Stack>
						</Stack>
						<Stack position={'absolute'} top={-8} left={'var(--pixel30)'}>
							<Avatar
								sx={{ width: '50px', height: '50px' }}
								src={speaker?.speakerImage?.url || '/images/icons/defaultUser.svg'}

							/>
						</Stack>
					</Grid>
				))}
			</Grid>
		</>
	);
};

export default Speakers;